import { Divider } from "@/components/shared/divider";
import { Typography } from "@/components/shared/typography";
import { Card, View } from "@/components/ui";
import { formatPrice } from "@/lib/helpers/number";
import { cn } from "@/lib/utils";

export const NormalTimeSlotCard = ({
  active,
  timeRange,
  rateValue,
  discount,
  priceWithTax,
  isCheaper,
  onCardClick,
  hidePricing,
}: {
  rateValue?: number;
  timeRange: string;
  discount?: number;
  active?: boolean;
  priceWithTax: string;
  isCheaper?: boolean;
  onCardClick?: () => void;
  hidePricing?: boolean;
}) => {
  return (
    <Card
      onClick={onCardClick}
      className={cn(
        "grow-0 cursor-pointer px-2 py-3 hover:divide-primary-border hover:bg-primary-surface md:p-4",
        {
          "border-primary-border bg-primary-surface": active,
        },
      )}
    >
      <Typography variant="body-sm" align={hidePricing ? "center" : "left"}>
        {timeRange}
      </Typography>
      {!hidePricing && (
        <>
          <Divider dashed className={cn({ "border-primary-border": active })} />
          <View className="flex flex-col gap-1">
            <Typography
              variant="label-sm"
              color={isCheaper ? "success" : "brand-primary"}
            >
              {rateValue && `${formatPrice(rateValue)}/hr`}{" "}
              {discount && `(${discount}% OFF!)`}
            </Typography>
            <Typography variant="caption-md" color="foreground-intermediate">
              {priceWithTax}
            </Typography>
          </View>
        </>
      )}
    </Card>
  );
};
